import i18n from '@shared/services/i18n/i18n';

const DEFAULT_LOCALE = 'ru';

export const formatNumber = (value: number, locale?: string) =>
  new Intl.NumberFormat(locale ?? i18n.language ?? DEFAULT_LOCALE).format(value);
